const allTiers = {
  bronze: {
    title: "BRONZE",
    price: "$0 - $449",
    min_price: 0,
    next_threshold: 500,
  },
  silver: {
    title: "SILVER",
    price: "$500 - $2449",
    min_price: 500,
    next_threshold: 2500,
  },
  gold: {
    title: "GOLD",
    price: "$2500 - $4999",
    min_price: 2500,
    next_threshold: 5000,
  },
  platinum: {
    title: "PLATINUM",
    price: "$5000+",
    min_price: 5000,
    next_threshold: 99999
  }
};


const getTier = (tierName) => {
  const cleanTierName = tierName.toLowerCase().replaceAll(" ", "-");
  const tier = allTiers[cleanTierName];
  return tier;
};

function updateSpendProgress(currentSpend, minSpend, maxSpend) {
  const percentage = Math.min(Math.max((currentSpend - minSpend) / (maxSpend - minSpend) * 100, 0), 100);

  const progressBar = document.querySelector('.rewards-details__parent-container .progress-bar');
  progressBar.style.width = `${percentage}%`;

  const currentSpendLabel = document.querySelector('.rewards-details__parent-container .current-spend-label');
  currentSpendLabel.innerHTML = `${currentSpend.toFixed(2)}`;

  const nextTierLabel = document.querySelector('.rewards-details__parent-container .next-tier-label');
  nextTierLabel.innerHTML = `${maxSpend.toFixed(2)}`;
}


// Utility function to update innerHTML by class name
const updateElement = (selector, content) => {
  const element = document.querySelector(selector);
  if (element) {
    element.innerHTML = content;
  }
};

const createRewardsItem = (reward) => {
  return `
    <div class="reward-detail__info_container">
        <p class="reward-detail__title uppercase bold">${reward?.description}</p>
        <p>Available: $${Number(reward?.available).toFixed(2)}</p>
        <p>Expiry: ${formatDate(reward?.expires_at)}</p>
    </div>`;
};

const getRewards = async (email) => {
  const response = await dotApparel("api-rewardsAccount", {
    method: "POST",
    body: { email },
  });
  const reward = response.data;
  return reward;
};

// Fetches all rewards when user logged in and saves into session storage
window.fetchUserRewards = async function fetchUserRewards(email, customerId) {
  try {
    if (!email || !customerId) throw new Error("Not logged in");
    const rewards = await getRewards(email);
    if (!rewards) throw new Error("No rewards data found");

    sessionStorage.setItem("userRewards", JSON.stringify(rewards));

    return {
      error: false,
      message: null,
    };
  } catch (error) {
    console.error("[ERROR] Rewards:", error.message);
    return {
      error: true,
      message: error.message,
      data: null
    };
  }
};

const rewardsChecker = async (reward, email) => {
  let rewardsData = reward

  if (rewardsData) {
    rewardsData = JSON.parse(reward)
  } else {
    rewardsData = await getRewards(email);
    if (!rewardsData) throw new Error("No rewards data found");
  }

  return rewardsData
}

window.cartDrawerRewards = async function cartDrawerRewards(email, customerId) {
  if (!email || !customerId) throw new Error("Not logged in");

  let reward = sessionStorage.getItem("userRewards");
  reward = await rewardsChecker(reward, email)

  updateElement('.cart-rewards__balance', `$${Number(reward.available_rewards).toFixed(2)}`);
};

window.mainCartRewards = async function mainCartRewards(email, customerId, orderTotal) {
  if (!email || !customerId) throw new Error("Not logged in");

  let reward = sessionStorage.getItem("userRewards");
  reward = await rewardsChecker(reward, email)

  // Update current spend
  updateElement('.cart-loyalty__current-spend', `Current spend: $${reward?.current_spend}`);

  // Update after spend
  const afterSpendValue = parseFloat(reward?.current_spend.replace('$', '')) + parseFloat(orderTotal.replace('$', ''));
  updateElement('.cart-loyalty__after-spend', `After this order: $${afterSpendValue.toFixed(2)}`);

  // Update next tier
  updateElement('.cart-loyalty__next-tier', `Next tier: $${reward?.spend_to_next_tier}`);

  // Update rewards count
  updateElement('.cart-loyalty__rewards-count', `(${reward?.rewards?.length})`);

  // Update reward items
  if (reward?.rewards?.length > 0) {
    const rewardItemsContent = reward?.rewards
      .map(
        (reward) => `
                <div class="reward-detail__info_container">
                    <h6 class="reward-detail__title font-san-serif-extended">${reward?.description}</h6>
                    <div>
                        <p>Available: $${reward?.available}</p>
                        <p>Expiry: ${formatDate(reward.expires_at)}</p>
                    </div>
                </div>`
      )
      .join('');
    updateElement('.cart-loyalty__reward-items', rewardItemsContent);
  } else {
    updateElement('.cart-loyalty__reward-items', '<p>You have no current rewards available</p>');
  }

  // Update progress bar for current spend
  const progressBar = document.querySelector('.cart-loyalty__progress-bar.current-spend');
  if (progressBar) {
    const tier = getTier(reward?.tier_name);
    const percentage = Math.min(
      Math.max(((reward?.current_spend - tier?.min_price) / (tier?.next_threshold - tier?.min_price)) * 100, 0),
      100
    );
    progressBar.style.width = `${percentage}%`;
  }
};

window.allRewards = async function allRewards(email, customerId) {
  try {
    if (!email || !customerId) throw new Error("Not logged in");

    let reward = sessionStorage.getItem("userRewards");
    reward = await rewardsChecker(reward, email)

    const tier = getTier(reward.tier_name);

    const customerRewards = reward?.rewards;

    if (customerRewards.length > 0) {
      const rewardsContainer = document.querySelector('.reward-detail__container');

      customerRewards.forEach((reward) => {
        const rewardHtml = createRewardsItem(reward);
        rewardsContainer.innerHTML += rewardHtml;
      });
    } else {
      document.querySelector('.rewards-details__no-rewards').classList.remove('hidden');
    }

    const rewardsTotalAmount = `$${Number(reward?.available_rewards).toFixed(2)}`

    // Account dashboard
    updateElement('.dashboard-tier__title', tier?.title);
    updateElement('.dashboard-tier__range', tier?.price);
    updateElement('.dashboard-tier__amount', rewardsTotalAmount);

    // Account rewards
    updateElement('.rewards-details__available-rewards-amount', rewardsTotalAmount);
    updateElement('.rewards-banner__tier', tier?.title);
    updateElement('.rewards-banner__bracket', tier?.price);
    updateElement('.rewards__anniversary-date', formatDate(reward?.tier_join_date));
    updateElement('.current-spend-label', reward?.current_spend);
    updateElement('.next-tier-label', tier?.next_threshold);

    // Update progress bar
    updateSpendProgress(reward?.current_spend, tier?.min_price, tier?.next_threshold);

    return {
      error: false,
      message: null,
    };
  } catch (error) {
    console.error("[ERROR] Rewards:", error.message);
    return {
      error: true,
      message: error.message,
      data: null
    };
  }
};

